import Primary from "../layouts/Primary";
import {t} from "../../i18n";
import {useAsset} from "../../AssetHelper";

import './WifiReminder.css';

export default function WifiReminder() {
    const iphoneImage = useAsset("img/wifi/disable_apple_iphone.png")
    const androidImage = useAsset("img/wifi/disable_android_nougat.png")

    return <Primary>
        <div className={"wifiPanel"}>
            <span className={"wifiTitle"} dangerouslySetInnerHTML={{ __html: t`Please <em>TURN OFF Wi-Fi</em> on Phones, Tablets, and Hot Spots`}} />
            <br/>
            <span className={"wifiSubHeading"}><i>{t`Leave the Wi-Fi to the Robots!`}</i></span>

            <div className={"wifiScreenshots"}>
                <div className={"wifiScreenshot"}>
                    <div>Apple iPhone</div>
                    { iphoneImage ? <img src={iphoneImage} /> : null}
                </div>

                <div className={"wifiScreenshot"}>
                    <div>Android Nougat</div>
                    { androidImage ? <img src={androidImage} /> : null}
                </div>
            </div>
        </div>
    </Primary>;
}